<template>
  <ion-page>
<!--    <ion-header :translucent="true">-->
<!--      <ion-toolbar>-->
<!--        <ion-title>Home</ion-title>-->
<!--        <ion-buttons slot="end">-->
<!--          <ion-button @click="logout">Logout</ion-button>-->
<!--        </ion-buttons>-->
<!--      </ion-toolbar>-->
<!--    </ion-header>-->

    <ion-content :fullscreen="true">
      <div class="ion-padding ion-text-center">
        <ion-button @click="handleOpen" expand="block">
          iframe test
        </ion-button>
      </div>

      <div v-if="true" class="iframe-container">
        <div class="iframe-header">
          <span>Web Simulation Mode</span>
          <ion-button fill="clear" size="small" @click="showWebIframe = false">Close</ion-button>
        </div>
        <iframe
            src="http://192.168.1.57:8080?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjoiNDNFRjBjal8zNFdNMWtLczd0QmhaQWtOblA4bm9NeTEwM0ZVNFlvR254dG9pZWIxb1F5WmtYQ1JxWGZJNXdsR3JPVXREVUV3aXFhSnZVMnotUG9xNkN6SUduRW5HUWZueUlqem9LekxSbkZmN2tYelRpd1V6bUVqSUg5X2VtSjdVZTd1VzUzZW9YellMZm5YVGs2X0RoMXU3UT09IiwiZXhwIjoxNzc1NDY2MjgxLCJpYXQiOjE3NzU0NjU5ODEsInBsYWluRGF0YSI6IntcIkN1aVwiOlwiMGQ2NDgzNTctZTgwMS00YzBhLTljZDItOWExMTIzYmU0MjE5XCIsXCJFbVwiOlwieXVsaWEuZ0BoZWlsYXN5c3RlbXMuY29tXCIsXCJFbnZcIjpcIkxPQ0FMXCIsXCJGblwiOlwi15nXldec15nXlFwiLFwiSWRcIjpcIjIwOTEyNDU3N1wiLFwiTG5cIjpcIteS15zXldeX15XXkVwiLFwiTG5nXCI6XCJoZVwiLFwiUmxcIjpbXCJkZXZlbG9wZXJcIixcImRyaXZlclwiLFwiaXRcIl0sXCJTcnZcIjpbXCJkcml2ZXJzXCIsXCJxYmlcIixcImRtcFwiLFwiY2hhdFwiXSxcIlN0clwiOlwiNjMxXCJ9In0.PFuWftW8L0v763rRaR_YRBPu1Nz-sg_b22mpq8OLdzk&origin=http://192.168.1.57:29530"
            class="full-iframe service-iframe"
        ></iframe>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { IonButton, IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, isPlatform } from '@ionic/vue';
import { useAuth } from '@/composables/useAuth';
import { InAppBrowser } from '@capacitor/inappbrowser';

const { logout } = useAuth();

const isNative = computed(() => isPlatform('capacitor'));
const showWebIframe = ref(false);

const handleOpen = async () => {
  if (isNative.value) {
    // Native Logic - All properties included to satisfy strict WebViewOptions interface
    await InAppBrowser.openInWebView({
      url: 'https://dominos-qbi-qa.heilasystems.com',
      options: {
        showToolbar: true,
        toolbarPosition: 0, // TOP
        closeButtonText: 'Back',
        showURL: false,
        clearCache: false,
        clearSessionCache: false,
        mediaPlaybackRequiresUserAction: false,
        showNavigationButtons: false,
        leftToRight: true,
        // Platforms objects are often required as non-optional in some plugin versions
        android: {
          allowZoom: true,
          hardwareBack: true,
          pauseMedia: true
        },
        iOS: {
          allowOverScroll: true,
          enableViewportScale: false,
          allowInLineMediaPlayback: false,
          surpressIncrementalRendering: false,
          viewStyle: 2, // FULL_SCREEN
          animationEffect: 2, // COVER_VERTICAL
          allowsBackForwardNavigationGestures: true
        }
      }
    });
  } else {
    showWebIframe.value = true;
  }
};
</script>

<style scoped>
.iframe-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 999;
  display: flex;
  flex-direction: column;
}

.iframe-header {
  background: #f4f4f4;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 15px;
  border-bottom: 1px solid #ccc;
  color: black;
}

.full-iframe {
  flex: 1;
  width: 100%;
  border: none;
}
</style>